export default __webpack_public_path__ + "static/media/misc-pantry2-2048w.f617f990.avif";